import { render, staticRenderFns } from "./CoTwoMealForm.vue?vue&type=template&id=cafe2bd0&scoped=true&"
import script from "./CoTwoMealForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoMealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe2bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cafe2bd0')) {
      api.createRecord('cafe2bd0', component.options)
    } else {
      api.reload('cafe2bd0', component.options)
    }
    module.hot.accept("./CoTwoMealForm.vue?vue&type=template&id=cafe2bd0&scoped=true&", function () {
      api.rerender('cafe2bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoMealForm.vue"
export default component.exports